import React from 'react';
import { useTranslation } from 'react-i18next';
import logo from "../../assets/JomUntu Logo.png";
import logoWhite from "../../assets/Logo bardh ellipse.png";

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-customRedOrange text-white py-8 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex justify-center mb-8">
          <div className="w-20 h-20 rounded-full flex items-center justify-center">
            <img 
              src={logoWhite}
              alt="Jomuntu" 
              className="h-12"
            />
          </div>
        </div>

        <div className="flex justify-center mb-8">
          <img 
            src={logo}
            alt="Jomuntu" 
            className="h-12"
          />
        </div>

        <div className="text-center mb-8">
          <p className="text-xl">{t("footer.slogan")}</p>
        </div>

        <div className="text-center mb-8">
          <h3 className="text-xl font-semibold mb-2">{t("footer.contact")}</h3>
          <p className="mb-1">{t("footer.email")}</p>
          <p>{t("footer.phone")}</p>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center border-t border-red-600 pt-4">
          <p className="text-sm mb-4 md:mb-0">
            {t("footer.rights")}
          </p>
          
          <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8">
            <a href="#" className="hover:underline">{t("footer.terms")}</a>
            <a href="#" className="hover:underline">{t("footer.privacy")}</a>
            <a href="#" className="hover:underline">{t("footer.faq")}</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
